import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const EliaButton = ({ status }) => {
    const [isHovered, setIsHovered] = useState(status === "active" ? true : false);

    const shapes = [
        "path('M 159 87.928 C 159 106.293 146.758 120.222 135.08 132.595 C 122.501 145.921 109.761 157 90 157 C 71.551 157 59.14 144.401 46.76 132.595 C 33.568 120.014 21 107.607 21 87.928 C 21 68.485 33.611 57.521 46.76 46.024 C 59.41 34.964 72.235 23 90.92 23 C 110.681 23 122.501 32.697 135.08 46.024 C 146.758 58.397 159 69.562 159 87.928 Z')",
        "path('M 155 90.568 C 155 96.294 155 118.051 151.244 125.422 C 147.488 132.794 98.126 161.564 88.5 160.992 C 78.874 160.419 33.74 130.837 28.911 125.422 C 24.082 120.007 24.619 98.011 24.082 90.568 C 23.546 83.125 25.692 60.223 28.911 53.925 C 32.13 47.627 78.338 19 88.5 19 C 98.662 19 147.488 45.91 151.244 53.925 C 155 61.941 155 84.843 155 90.568 Z')",
        "path('M 159 87.928 C 159 106.293 146.758 120.222 135.08 132.595 C 122.501 145.921 109.761 157 90 157 C 71.551 157 59.14 144.401 46.76 132.595 C 33.568 120.014 21 107.607 21 87.928 C 21 68.485 33.611 57.521 46.76 46.024 C 59.41 34.964 72.235 23 90.92 23 C 110.681 23 122.501 32.697 135.08 46.024 C 146.758 58.397 159 69.562 159 87.928 Z')",
        "path('M 155 90.568 C 155 96.294 155 118.051 151.244 125.422 C 147.488 132.794 98.126 161.564 88.5 160.992 C 78.874 160.419 33.74 130.837 28.911 125.422 C 24.082 120.007 24.619 98.011 24.082 90.568 C 23.546 83.125 25.692 60.223 28.911 53.925 C 32.13 47.627 78.338 19 88.5 19 C 98.662 19 147.488 45.91 151.244 53.925 C 155 61.941 155 84.843 155 90.568 Z')",
        "path('M 159 87.928 C 159 106.293 146.758 120.222 135.08 132.595 C 122.501 145.921 109.761 157 90 157 C 71.551 157 59.14 144.401 46.76 132.595 C 33.568 120.014 21 107.607 21 87.928 C 21 68.485 33.611 57.521 46.76 46.024 C 59.41 34.964 72.235 23 90.92 23 C 110.681 23 122.501 32.697 135.08 46.024 C 146.758 58.397 159 69.562 159 87.928 Z')",
    ]

    return (
        <div className="elia-button-wrapper">
            <motion.button
                className="elia-custom-button"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(status === "active" ? true : false)}
                whileTap={{ scale: 0.95 }}
            >
                <AnimatePresence>
                    {isHovered && (
                        <motion.div
                            className="morphing-bg"
                            initial={{ opacity: 0, scale: 0.1, x: "-50%", y: "-50%", rotate: 0 }}
                            animate={{
                                opacity: 1,
                                scale: 0.30,
                                x: "-50%",
                                y: "-50%",
                                clipPath: shapes,
                                rotate: 360,
                                filter: ["hue-rotate(0deg)", "hue-rotate(90deg)", "hue-rotate(0deg)"]
                            }}
                            exit={{ opacity: 0, scale: 0, x: "-50%", y: "-50%" }}
                            style={{
                                background: "linear-gradient(135deg, #a78bfa 0%, #3b82f6 50%, #2dd4bf 100%)",
                            }}
                            transition={{
                                clipPath: {
                                    duration: 5,
                                    repeat: Infinity,
                                    ease: "easeInOut",
                                    times: [0, 0.25, 0.5, 0.75, 1]
                                },
                                rotate: {
                                    duration: 10,
                                    repeat: Infinity,
                                    ease: "linear"
                                },
                                filter: {
                                    duration: 4,
                                    repeat: Infinity,
                                    ease: "easeInOut"
                                },
                                opacity: { duration: 0.3 },
                                scale: { duration: 0.3 }
                            }}
                        />
                    )}
                </AnimatePresence>
                <motion.span
                    className={`elia-icon-wrapper ${isHovered ? 'elia-icon-wrapper-hovered' : ''}`}
                    animate={{
                        rotate: isHovered ? 360 : 0
                    }}
                    transition={{ duration: 0.5 }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 512 512" fill="none" role="img" aria-label="Étoile avec dégradé Elia">
                        <defs>
                            <linearGradient id="elia-gradient" x1="98" y1="82" x2="414" y2="430" gradientUnits="userSpaceOnUse">
                                <stop offset="0%" stopColor="#124188" />
                                <stop offset="38%" stopColor="#124188" />
                                <stop offset="72%" stopColor="#997adb" />
                                <stop offset="100%" stopColor="#aec353" />
                            </linearGradient>
                        </defs>
                        <path d="M256 82        C266 171 318 242 414 256        C318 270 266 341 256 430        C246 341 194 270 98 256        C194 242 246 171 256 82Z" fill="url(#elia-gradient)" />
                    </svg>
                </motion.span>
            </motion.button>
        </div>
    );
};

export default EliaButton;
